/**
 * Logo Component
 * Agify logo with customizable size
 */

import React from 'react';

export interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img src="/images/agify-logo-text.svg" alt="Agify" className={`h-8`} />
    </div>
  );
};
